/**
 * 从 url 中获取指定参数的值
 * */
const getQueryValueByName = (param, url) => {
    let queryArr
    if (!url) queryArr = window.location.search?.slice(1)?.split('&')
    else queryArr = url.split('?')[1]?.split('&')
    if(!queryArr) return ''
    const queryPair = queryArr.find(query => query.split('=')[0] === param);
    return queryPair?.split('=')[1] || ''
}

export default getQueryValueByName
